import { ChangeDetectionStrategy, Component, Input, OnChanges, OnInit, inject, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AnswerByRecipient, QuestionData } from 'src/app/models/QuestionnaireDataByQuestions.model';
import { DataSummaryStore } from 'src/app/features/questionnaires/store/data-summary-store';
import { Recipient } from 'src/app/models/recipients.model';
import { ContactCircleComponent } from '../../contact-circle/contact-circle.component';
import { Question } from 'src/app/models/question.model';
import { Answer } from 'src/app/models/Answer.model';
import { ModularQuestion } from 'src/app/models/modularQuestion.model';
import { AnswerRowToGroupComponent } from '../answer-row-to-group/answer-row-to-group.component';
import { toSignal } from '@angular/core/rxjs-interop';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'que-answer-group-to-recipient',
    imports: [CommonModule, ContactCircleComponent, AnswerRowToGroupComponent, TranslateDirective, TranslatePipe],
    templateUrl: './answer-group-to-recipient.component.html',
    styleUrls: ['./answer-group-to-recipient.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AnswerGroupToRecipientComponent implements OnChanges {
  @Input()
  questionData?: QuestionData;
  @Input()
  recipient?: Recipient;
  answers: Answer[] = []
  answersSource: Answer[] = []
  #storeData = inject(DataSummaryStore);
  showComparison$ = toSignal(this.#storeData.showComparison$);
  // modularQuestions: { question: ModularQuestion, answers: Answer[] }[] = []
  rows$ = signal(1);
  rowsSource$ = signal(1);
  ngOnChanges(): void {
    if (this.questionData) {
      this.answers = [...this.questionData?.recipients?.filter(r => r.recipient.id == this.recipient?.id).map(r => { return { ...r.answer, wasChange: r.wasChange } as Answer }) ?? []];
      var orders = [...this.answers.map(ans => ans.modularRowNum)
        .filter(order => order != undefined) ?? []] as number[];
      this.rows$.set(Math.max(...orders))

      this.answersSource = [...this.questionData?.recipients?.filter(r => r.recipient.id == this.recipient?.id).map(r => r.answerSource) ?? []];
      var orders = [...this.answersSource.filter(x => x != null).map(ans => ans.modularRowNum)
        .filter(order => order != undefined) ?? []] as number[];
      this.rowsSource$.set(Math.max(...orders))

    }
  }
}
